module.exports = __webpack_public_path__ + "img/Home_SecSchool_Teachers.6e9313a1.jpg";